import { css } from '@huspy/styled-system/css';

const referredLeadsTableStyles = {
  container: css({ paddingY: 8 }),
  table: css({
    position: 'relative',
    marginTop: 6,
  }),
};

export default referredLeadsTableStyles;
